/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { shapes } from '@greenville/framework';
import { Box } from '@mui/material';
import Profile from './Profile';

const styles = () => ({
  logo: {
    cursor: 'pointer',
    width: '115px',
    marginLeft: '28px',
    marginTop: '-6px'
  },
  headerContainer: {
    width: '100%',
    paddingLeft: '20px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    '@media (max-width: 480px)': {
      padding: '0'
    }
  }
});

const TopStrap = ({ id, language, classes, user, ...rest }) => {
  const { tenantname } = useParams();
  const history = useHistory();

  const handleRedirect = () => {
    history.push(`/aiadmin/${tenantname}`);
  };

  return (
    <header id={id} className={classes.headerContainer} {...rest}>
      <Box
        component="img"
        src="/images/pearsonlogo.svg"
        alt="Pearson Logo"
        title="Click here to go to the home page."
        className={classes.logo}
        onClick={handleRedirect}
      />
      {user.id !== '' && <Profile />}
    </header>
  );
};

TopStrap.defaultProps = {
  id: 'topstrap'
};

TopStrap.propTypes = {
  id: PropTypes.string,
  language: shapes.language.isRequired,
  classes: PropTypes.object.isRequired,
  user: shapes.user.isRequired
};

export default withStyles(styles)(inject('language', 'user')(observer(TopStrap)));
